import { useSWRConfig } from "swr";
import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

// useUpdateOrgName allows a user to update their own organization's name
export function useUpdateOrgName() {
  const accessToken = getUserToken();
  const { mutate, cache } = useSWRConfig();

  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return (name: string): Promise<void> =>
    service
      .patch("/api/org/setting/name")
      .set(headers)
      .send({ name })
      .then(tokenRefreshHandler)
      .then((res: Response) => res.body)
      .then((res: ReadableStream<Uint8Array> | null) => {
        // @ts-ignore - the type for `cache` does not explicitly define `keys`
        const keys: IterableIterator<string> = cache.keys();

        // invalidate org queries and force refresh
        Array.from(keys)
          .filter((route: string) => route.includes("/api/org"))
          .forEach((route: string) => {
            mutate(route);
          });
        return res;
      })
      .catch(errorHandler);
}
